import type { FC } from 'react'
import { useSuspenseQuery } from '../../../services'
import { HoverCard, HoverCardContent, HoverCardTrigger } from '@bpinternal/ui-kit-next'
import { UserAvatar } from '../../../componentsV2'
import { Avatar, StyledLink } from '../../../elementsv2'

type Props = {
  count?: number
  workspaceId: string
}

export const MembersPreview: FC<Props> = ({ count = 6, workspaceId }) => {
  const workspaceMembers = useSuspenseQuery('workspaces_/$workspaceId_/members', { workspaceId }).data

  const shownMemebers = workspaceMembers.slice(0, count)
  const hiddenMembers = workspaceMembers.slice(count)

  return (
    <div className="flex flex-col gap-4">
      <span className="text-sm font-medium text-gray-12">Members</span>
      <div className="flex flex-wrap gap-2">
        {shownMemebers?.map((member) => (
          <HoverCard key={member.id}>
            <HoverCardTrigger>
              <UserAvatar
                className="h-8 w-8 cursor-pointer text-base"
                userId={member.userId ?? undefined}
                workspaceId={workspaceId}
              />
            </HoverCardTrigger>
            <HoverCardContent side="top">
              <div className="gap-2">
                <Avatar className="h-9 w-9 text-base" name={member.email} />
                <div className="flex flex-col">
                  <span className="text-sm font-medium">{member.email}</span>
                  <span className="text-xs text-gray-11">{member.role}</span>
                </div>
              </div>
            </HoverCardContent>
          </HoverCard>
        ))}
      </div>
      <StyledLink className="text-xs" to="/workspaces/$workspaceId/settings/members" params={{ workspaceId }}>
        {hiddenMembers.length === 0 ? 'View all members' : `+ ${hiddenMembers.length} more members`}
      </StyledLink>
    </div>
  )
}
